<app-modal-frame
  [headerText]="isEditMode ? CONST.EDIT : CONST.NEW"
  (emitExit)="onClose($event)"
>
  <div [formGroup]="uldForm" class="uld-modal-container">
    <ion-row>
      <!-- Sort Date -->
      <ion-col size="auto" class="custom-col">
        <div
          class="md-control sort-date-picker-container"
          [ngClass]="{
            'disabled-date-picker-container': isFirstStepControlDisabled,
          }"
        >
          <p class="date-label">
            {{ CONST.SORT_DATE }} <span class="required-field">*</span>
          </p>
          <app-form-date-picker
            [icon]="SRC.CALENDAR"
            [placeholder]="CONST.SELECT_DATE"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [formControlName]="IDS.SORT_DATE"
            [required]="true"
            [disabled]="isFirstStepControlDisabled"
          ></app-form-date-picker>
        </div>
      </ion-col>

      <!-- Sort Code -->
      <ion-col size="auto" class="select-col">
        <div
          class="md-control lg-select common-select"
          [ngClass]="{
            'disabled-dropdown-container': isFirstStepControlDisabled,
          }"
        >
          <app-form-select
            [label]="CONST.SORT"
            [options]="SORT_LIST"
            [customClass]="'new-uld-select sort-select'"
            [formControlName]="IDS.SORT"
            [hasRequiredSign]="true"
            [placeholder]="CONST.SELECT"
            [isDisabled]="isFirstStepControlDisabled"
          >
          </app-form-select>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="mt-12">
      <!-- Position Belt -->
      <ion-col size="auto" class="custom-col">
        <div
          class="md-control text-box-container"
          [ngClass]="{
            'disabled-input-box-container': isFirstStepControlDisabled,
          }"
        >
          <app-form-input-field
            [label]="CONST.POSITION_BELT"
            [formControlName]="IDS.POSITION_BELT"
            [placeholder]="CONST.BELT_PLACEHOLDER"
            [required]="true"
            [disabled]="isFirstStepControlDisabled"
            [autoCapitalizeCharacters]="true"
          ></app-form-input-field>
        </div>
      </ion-col>

      <!-- Position Bay -->
      <ion-col size="auto">
        <div
          class="md-control text-box-container"
          [ngClass]="{
            'disabled-input-box-container': isFirstStepControlDisabled,
          }"
        >
          <app-form-input-field
            [label]="CONST.POSITION_BAY"
            [formControlName]="IDS.POSITION_BAY"
            [placeholder]="CONST.BAY_PLACEHOLDER"
            [required]="true"
            [disabled]="isFirstStepControlDisabled"
          ></app-form-input-field>
        </div>
      </ion-col>
    </ion-row>
    @if (currentStep !== FORM_STEP.FIRST) {
      <!-- Show Key chart only for outbound scan GLE -->
      @if (!data.isLoadKeyUpdate) {
        <!-- key chart -->
        <ion-row>
          <ion-col size="12">
            <label> {{ CONST.KEY_CHART.HEADER }}</label>

            <div class="key-chart-container">
              <ion-row>
                <!-- CO = Carryover load -->
                <ion-col size="6">
                  <span
                    >{{ CONST.KEY_CHART.CO }}={{
                      CONST.KEY_CHART.CARRY_OVER
                    }}</span
                  >
                </ion-col>
                <!-- BD = Bulk Delivery -->
                <ion-col size="6">
                  <span
                    >{{ CONST.KEY_CHART.BD }}={{
                      CONST.KEY_CHART.BULK_DELIVERY
                    }}</span
                  >
                </ion-col>
              </ion-row>
              <ion-row>
                <!-- BC = Bulk Carryover -->
                <ion-col size="6">
                  <span
                    >{{ CONST.KEY_CHART.BC }}={{
                      CONST.KEY_CHART.BULK_CARRYOVER
                    }}</span
                  >
                </ion-col>
                <!-- UP = UPS Premier -->
                <ion-col size="6">
                  <span
                    >{{ CONST.KEY_CHART.UP }}={{
                      CONST.KEY_CHART.UPS_PREMIER
                    }}</span
                  >
                </ion-col>
              </ion-row>
            </div>
          </ion-col>
        </ion-row>
      }
      <ion-row class="mt-12">
        <ion-col
          [size]="
            !!data.isLoadKeyUpdate && isInternationalLoadSelected ? 6 : 'auto'
          "
          class="custom-col select-col"
        >
          @if (data.isLoadKeyUpdate && !isLoadKeyDropdown) {
            <div class="selected-load">
              <p class="bold-label">
                Selected load:
                {{ gleLoads[0].selectedLoadName }}
              </p>
            </div>
          } @else {
            <div
              class="md-control common-select lg-select"
              [ngClass]="{
                'disabled-dropdown-container':
                  isSecondStepControlDisabled && !isInternationalLoadSelected,
              }"
            >
              <app-form-select
                [label]="isEditMode ? CONST.SELECTED_LOAD : CONST.LOAD"
                [options]="loadOptions"
                [customClass]="'new-uld-select load-select'"
                [formControlName]="IDS.LOAD"
                [hasRequiredSign]="!isEditMode"
                [placeholder]="CONST.SELECT_LOAD"
                [isDisabled]="
                  isSecondStepControlDisabled && !isInternationalLoadSelected
                "
              >
              </app-form-select>
            </div>
          }
        </ion-col>
        @if (
          currentStep === FORM_STEP.THIRD &&
          !!data.isLoadKeyUpdate &&
          isInternationalLoadSelected
        ) {
          <ion-col size="auto" class="pr-12 select-col">
            <div
              class="md-control common-select lg-select disabled-dropdown-container"
            >
              <app-form-select
                [label]="isEditMode ? CONST.SELECTED_MOVEMENT : CONST.MOVEMENT"
                [options]="MOVEMENT_OPTIONS"
                [customClass]="'new-uld-select movement-select'"
                [formControlName]="IDS.MOVEMENT"
                [hasRequiredSign]="true"
                [isDisabled]="true"
              >
              </app-form-select>
            </div>
          </ion-col>
        }
      </ion-row>
    }
    @if (currentStep === FORM_STEP.THIRD) {
      <ion-row class="mt-12">
        <ion-col size="auto" class="custom-col">
          <div
            class="md-control text-box-container"
            [ngClass]="{
              'disabled-input-box-container': isControlDisabled(),
            }"
          >
            <app-form-input-field
              [label]="CONST.EQUIPMENT_NUMBER"
              [formControlName]="IDS.EQUIPMENT_NUMBER"
              [placeholder]="
                isControlDisabled() ? '' : CONST.NUMBER_PLACEHOLDER
              "
              [regexType]="SPECIAL_CHARS"
              [maxLength]="11"
              [required]="true"
              [autoCapitalizeCharacters]="true"
              [disabled]="isControlDisabled()"
            ></app-form-input-field>
          </div>
        </ion-col>
        <ion-col size="auto" class="select-col">
          <div
            class="md-control common-select lg-select"
            [ngClass]="{
              'disabled-dropdown-container': isControlDisabled(),
            }"
          >
            <app-form-select
              [label]="CONST.EQUIPMENT_TYPE"
              [options]="TYPE_OPTIONS"
              [customClass]="'new-uld-select equipment-type-select'"
              [formControlName]="IDS.EQUIPMENT_TYPE"
              [required]="true"
              [placeholder]="isControlDisabled() ? '' : CONST.TYPE_PLACEHOLDER"
              [isDisabled]="isControlDisabled()"
            >
            </app-form-select>
          </div>
        </ion-col>
      </ion-row>
      @if (isInternationalLoadSelected) {
        <ion-row class="mt-12">
          <ion-col size="auto" class="custom-col">
            <div
              class="md-control text-box-container"
              [ngClass]="{
                'disabled-input-box-container': isControlDisabled(),
              }"
            >
              <app-form-input-field
                [label]="CONST.SEAL_CONTROL"
                [formControlName]="IDS.SEAL_CONTROL"
                [placeholder]="
                  isControlDisabled() ? '' : CONST.SEAL_CONTROL_PLACEHOLDER
                "
                [required]="true"
                [autoCapitalizeCharacters]="true"
                [disabled]="isControlDisabled()"
              ></app-form-input-field>
            </div>
          </ion-col>
        </ion-row>
      }
    }
    @if (!isEditMode) {
      @switch (currentStep) {
        @case (FORM_STEP.FIRST) {
          <div class="footer step1">
            <ion-button
              class="next-btn footer-btn"
              [disabled]="uldForm.invalid"
              (click)="formSecondStep()"
            >
              {{ CONST.NEXT }}
            </ion-button>
          </div>
        }
        @case (FORM_STEP.SECOND) {
          <div class="footer">
            <ion-button
              class="back-btn footer-btn"
              fill="outline"
              (click)="backToFirstStep()"
            >
              {{ CONST.BACK }}
            </ion-button>
            <ion-button
              class="next-btn footer-btn"
              [disabled]="uldForm.invalid"
              (click)="formThirdStep()"
            >
              {{ CONST.NEXT }}
            </ion-button>
          </div>
        }
        @case (FORM_STEP.THIRD) {
          <div class="footer">
            <ion-button
              class="back-btn footer-btn"
              fill="outline"
              (click)="backToSecondStep()"
            >
              {{ CONST.BACK }}
            </ion-button>
            <ion-button
              class="next-btn footer-btn"
              [disabled]="isControlDisabled() ? false : uldForm.invalid"
              (click)="submit()"
            >
              {{ CONST.SUBMIT }}
            </ion-button>
          </div>
        }
      }
    } @else {
      <div class="footer">
        <ion-button
          class="back-btn footer-btn"
          fill="outline"
          (click)="cancel()"
        >
          {{ CONST.CANCEL }}
        </ion-button>
        <ion-button
          class="next-btn footer-btn"
          [disabled]="uldForm.invalid"
          (click)="save()"
        >
          {{ CONST.SAVE }}
        </ion-button>
      </div>
    }
  </div>
</app-modal-frame>
